/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import clsx from 'clsx';

interface Props {
  component: any;
  id?: string;
  isSelected: boolean;
  isCustom?: boolean;
  option: any;
  onClick: any;
  'data-testid'?: string;
}

export default class BasicDropdownOptionWrapper extends React.PureComponent<Props> {
  handleClick = (event: React.MouseEvent<any>) => {
    this.props.onClick(event, this.props.option);
  };

  render() {
    const { component: Component, isSelected, option, isCustom } = this.props;
    const className = clsx('BasicDropdown-option', {
      'BasicDropdown-option-custom': isCustom,
      'is-selected': isSelected,
    });

    return (
      <button
        role="option"
        id={this.props.id}
        aria-selected={isSelected}
        className={className}
        onClick={this.handleClick}
        data-testid={this.props['data-testid']}
      >
        <div className="BasicDropdown-optionContent">
          <Component
            id={option.value}
            isSelected={isSelected}
            option={option}
            onSelect={this.handleClick}
          />
        </div>
      </button>
    );
  }
}
